import { gql } from "@apollo/client";export default gql`mutation DeleteBlocks($ids: [Int!]!) {
    delete_worksheet_block(where: { id: { _in: $ids } }) {
        affected_rows
    }
}
`;
